"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationsReportRefreshResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_validator_1 = require("class-validator");
class CommunicationsReportRefreshResponseDto extends mappable_base_1.MappableBase {
    /* JSDOC ---------------------------------------------------------------------
     * @property {number} id
     * @property {BehaviorCodeNotificationStatus} status
     * --------------------------------------------------------------------------
     */
    constructor(options) {
        super();
        if (options)
            this.assignFields(options);
    }
    assignFields(options) {
        const fields = this.getFields();
        fields.forEach((field) => {
            if (options && options[field] !== undefined) {
                this[field] = options[field];
            }
        });
    }
    mapFields(source, skipNested = false, skipTransforms = false) {
        super.mapFields(source, skipNested, skipTransforms);
        return this;
    }
    getFields() {
        return [
            'id',
            'status'
        ];
    }
    id;
    status;
}
exports.CommunicationsReportRefreshResponseDto = CommunicationsReportRefreshResponseDto;
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], CommunicationsReportRefreshResponseDto.prototype, "id", void 0);
